import React from "react";

import { connect } from 'react-redux';
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";

import PrimaryButton from "../../../../../../../components/Buttons/PrimaryButton";
import BaseDialog from "../../../../../../../components/BaseDialog/BaseDialog";
import ConfirmDeleteModal from "../../../../../../../components/BaseDialog/components/ConfirmDeleteModal";

import styles from "./styles";


const SyncWarnPopup = (props) => {
  const {
    classes,
    open,
    title,
    handleClose,
    setSynced,
    handleYesClick,
    children,
  } = props;

  const [confirmNoShown, setConfirmNoShown] = React.useState(false);
  const [modalLoading, setModalLoading] = React.useState(false);
  const onNoClick = React.useCallback(() => setConfirmNoShown(true), []);
  const cancelNoConfirm = React.useCallback(() => setConfirmNoShown(false), []);

  const confirmNo = async () => {
    setModalLoading(true);

    if(await setSynced(props.dispatch)){
      handleClose();
    }

    setConfirmNoShown(false);
    setModalLoading(false);
  };

  return (
    <>
      <BaseDialog
        open={open}
        title={<><i className={'far fa-exclamation-circle'} />&nbsp;{title}</>}
        data-id={'other-assets-and-liabilities-sync-warning-popup'}
        handleClose={handleClose}
        customClasses={classes}
        maxWidth={'lg'}
        actions={
          <Grid container spacing={1} justify={"flex-end"}>
            <Grid item>
              <PrimaryButton
                variant={'outlined'}
                text={'Abbrechen'}
                onButtonClick={handleClose}
              />
            </Grid>
            <Grid item>
              <PrimaryButton
                variant={'outlined'}
                text={'Nein'}
                onButtonClick={onNoClick}
              />
            </Grid>
            <Grid item>
              <PrimaryButton
                text={'Ja'}
                onButtonClick={handleYesClick}
              />
            </Grid>
          </Grid>
        }
      >{children}</BaseDialog>
      <ConfirmDeleteModal
        open={confirmNoShown}
        title={'Bestätigung erforderlich'}
        deleteTitle={'Ja'}
        handleClose={cancelNoConfirm}
        onDeleteClick={confirmNo}
        modalLoading={modalLoading}
      >Sind Sie sicher? Diese Auswahl wird  nicht erneut angezeigt.</ConfirmDeleteModal>
    </>
  )
};

export default connect()(withStyles(styles)(SyncWarnPopup));